import React, { useState } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getToken } from '../../utils/tokenService.js';

const AccountForm = () => {
  const navigate = useNavigate();
  const [accountNumber, setAccountNumber] = useState({
    id_number: "",
    ifsc: "",
    ifsc_details: true
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  function changeHandler(e) {
    const { name, value } = e.target;

    const normalizedValue =
      name === "id_number"
        ? value.replace(/\D/g, "")
        : value.replace(/\s/g, "").toUpperCase();

    setAccountNumber({
      ...accountNumber,
      [name]: normalizedValue
    });
  }

  const handleCancel = (e) => {
    e.preventDefault();
    navigate('/user_dashboard/user_profile');
  };

  async function generateAccount(e) {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    const userToken = await getToken();
    const payload = {
      id_number: accountNumber.id_number.trim(),
      ifsc: accountNumber.ifsc.trim().toUpperCase(),
      ifsc_details: true,
    };

    if (!payload.id_number || !payload.ifsc) {
      toast.error('Account Number and IFSC Code are required');
      return;
    }

    if (!userToken) {
      toast.error('Session expired. Please login again.');
      navigate('/app-login');
      return;
    }

    setIsSubmitting(true);

    try {
      const verifyResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/user/profile/verify-bank-account`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      if (!verifyResponse?.data?.success) {
        toast.error(verifyResponse?.data?.message || 'Bank verification failed');
        return;
      }

      const addAccountData = {
        account_number: payload.id_number,
        data: verifyResponse.data.data
      };

      const addResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/user/profile/add_Account`,
        addAccountData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`
          }
        }
      );

      if (addResponse?.data?.success) {
        navigate("/user_dashboard/user_profile");
        toast.success(addResponse.data.message);
      } else {
        toast.error(addResponse?.data?.message || 'Account not added');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Try Again..');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className='pan_form'>
      <div className="form-box">
        <h1 className='mb-3'>Add Bank Account</h1>
        {/* <p>Using <a href="https://getbootstrap.com">Bootstrap</a> and <a href="https://www.formbucket.com">FormBucket</a></p> */}
        <form onSubmit={generateAccount}>
          <div className="form-group">
            <label htmlFor="account_number">Account Number</label>
            <input
              className="form-control"
              id="id_number"
              type="text"
              name="id_number"
              inputMode="numeric"
              autoComplete="off"
              value={accountNumber.id_number}
              onChange={changeHandler}
            />
          </div>
          <div className="form-group mt-3" id='otp_box'>
            <label htmlFor="ifsc">IFSC Code</label>
            <input
              className="form-control"
              id="ifsc"
              type="text"
              name="ifsc"
              autoCapitalize="characters"
              autoCorrect="off"
              autoComplete="off"
              spellCheck={false}
              maxLength="11"
              value={accountNumber.ifsc}
              onChange={changeHandler}
            />
          </div>
          <div className='d-flex gap-3 mt-4'>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Adding...' : 'Add'}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountForm;
